import { useSupplyPlanAudit } from '@/api/hooks/useSupplyPlans'
import { AuditModalView } from '@/pages/Dashboard/panels/ConnectionLogsPanel/components/AuditModal/AuditModal'

interface SupplyPlanAuditModalProps {
  supplyPlanId: string | null
  open: boolean
  onClose: () => void
}

/**
 * The mapping engine's translation audit for one supply plan, rendered with the
 * same flow view the order integration logs use.
 *
 * Routing is backfilled onto the audit by the endpoint (it lives on the supply
 * plan, not the audit), so no routing prop is needed here.
 */
export function SupplyPlanAuditModal({
  supplyPlanId,
  open,
  onClose,
}: SupplyPlanAuditModalProps) {
  const { data: audit, isLoading, error } = useSupplyPlanAudit(supplyPlanId)

  return (
    <AuditModalView
      open={open}
      onClose={onClose}
      title='Translation Audit'
      audit={audit}
      isLoading={isLoading}
      error={error}
    />
  )
}
